import type {MutableRefObject} from 'react';
import type {IconCollection} from '../../design-tokens/generated/Icons';
import collection from '../../design-tokens/generated/Icons';

export function isRefObject<T>(
    ref: ((instance: T | null) => void) | MutableRefObject<T | null> | null,
): ref is MutableRefObject<T> {
    return (ref as MutableRefObject<T>)?.current !== undefined;
}

export function isValidIconName(
    iconName: string,
): iconName is keyof IconCollection {
    return Object.hasOwn(collection, iconName);
}
